{
  "actions": "Acciones"
}
